<template>
  <div v-bind="$attrs" class="lp-card card" :class="propClasses">
    <slot :on-flip="onFlip" />
  </div>
</template>

<script setup lang="ts">
import { inject } from 'vue'
import { BaseProps, BASE_PROPS_DEFAULTS } from '@/models/types/BaseProps'
import { useBaseProps } from '@/hooks/useBaseProps'

type onFlipType = () => void

defineOptions({
  name: 'lp-card',
})

const props = withDefaults(defineProps<BaseProps>(), BASE_PROPS_DEFAULTS)
const { propClasses } = useBaseProps(props)

const onFlip: onFlipType = inject('onFlip', () => {
  return
})
</script>
